import { render } from "./OrderListComponent.vue?vue&type=template&id=594a5a90"
import script from "./OrderListComponent.vue?vue&type=script&lang=js"
export * from "./OrderListComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cose-cashier/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__